import { useState } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { InterviewList } from '@/components/interview/InterviewList';
import { InterviewScheduler } from '@/components/interview/InterviewScheduler';

export function InterviewsPage() {
  const [showScheduleDialog, setShowScheduleDialog] = useState(false);

  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-text-primary">Interviews</h1>
          <p className="text-text-secondary mt-1">
            Schedule and manage candidate interviews
          </p>
        </div>
        <Button onClick={() => setShowScheduleDialog(true)}>
          <Plus className="h-4 w-4 mr-2" />
          Schedule Interview
        </Button>
      </div>

      {/* Interview List with all filters, actions */}
      <InterviewList showSearch={true} />

      {/* Schedule Interview Dialog */}
      <InterviewScheduler
        open={showScheduleDialog}
        onOpenChange={setShowScheduleDialog}
      />
    </div>
  );
}
